<template>
  <div class="service-container">
    <top-nav :shrinked="true"/>
    <img class="banner page-banner" src="@/assets/myservice/banner.jpg">
    <div class="container-fluid">
      <div class="site-text__content">
        <h3 class="text-blue site-text__content_h3">享受科技与智能</h3>
        <div class="site-text__content_desc">
          <p>重塑空间效率 服务历久弥新</p>
        </div>
      </div>
      <div class="service-ln-content">
        <div class="img-bg">
<!--          <div class="title-content">-->
<!--            <span class="title1">客户服务</span>-->
<!--            <span class="title2">在您身边</span>-->
<!--            <span class="title-line">为您排忧</span>-->
<!--          </div>-->
          <div class="contact-container">
<!--            <div class="kf-item" @click="servicehandle">-->
<!--              <span>联系客服</span>-->
<!--              <span></span>-->
<!--            </div>-->
<!--            <div class="kf-item" @click="lsHandle">-->
<!--              <span>智能懒社</span>-->
<!--              <span></span>-->
<!--            </div>-->
          </div>
        </div>
      </div>
      <div class="site-text__content ls__content kf">
        <h3 class="text-blue site-text__content_h3">联系客服</h3>
        <div class="site-text__content_desc">
          <p>专注客服工作，提供包括咨询、报修、投诉、监督等全方位等服务，</p>
          <p>监督集团各项目地产、物业服务工作，欢迎您拨打客户服务监督热线。</p>
        </div>
      </div>
      <div class="service-ln-content">
        <div class="img-bg service-bg">
<!--          <div class="info-container">-->
<!--            <div class="time">工作时间:周一至周五 8:30-17:30</div>-->
<!--            <div class="min-title">客户服务监督热线</div>-->
<!--            <div class="phone">400-828-9980</div>-->
<!--            <div class="min-address">集团总部地址:江苏省常州市延陵西路19号嘉宏世纪大厦33楼</div>-->
<!--          </div>-->
        </div>
      </div>
      <div class="map-img ls">
        <div class="site-text__content ls__content">
          <h3 class="text-blue site-text__content_h3">智能懒社</h3>
          <div class="site-text__content_desc">
            <p>“懒社”移动服务平台,融入线下物业管理及服务，实现了线上线下双平台互通，</p>
            <p>帮助业主尽享便利生活，有效提高物业运营效率。</p>
          </div>
        </div>
        <img class="ls_img" src="@/assets/myservice/to.png">
        <div class="site-text__content ls__content">
          <h3 class="text-blue site-text__content_h3">服务理念</h3>
          <div class="site-text__content_desc">
            <p>始终将公司客户满意度保持在行业领先水平，持续提升嘉宏公司品牌美誉度和忠诚度。</p>
            <p>嘉宏锋芒不让，本色不藏。所有嘉宏业主交流平台，让沟通更容易，更好地服务</p>
          </div>
        </div>
        <div class="ln-content">
          <div v-for="(item,index) in serviceList" :key="index" class="ln-item">
            <img :src="require('@/assets/myservice/' + item.icon)"/>
            <div class="desc1">
              <p>{{item.p1}}</p>
              <p>{{item.p2}}</p>
              <div class="desc-line"></div>
            </div>
            <div class="desc2">
              <p>{{item.b1}}</p>
              <p>{{item.b2}}</p>
            </div>
          </div>
        </div>

        <div class="cp-content NioHouseFunction_nioHouseFunctionContainer__Slqkp">
          <div class="site-text__content ls__content">
            <h3 class="text-blue site-text__content_h3">产品及场景</h3>
          </div>
          <div class="slider-cp cp-slider_content">
            <div v-for="(item,index) in cpList" :key="index">
              <div class="cp-slider_item">
                <img :src="require('@/assets/myservice/' + item.img)"/>
                <div class="cp-slider_bottom">
                  {{item.name}}
                </div>
              </div>
            </div>
          </div>
          <div class="Carousel_carouselControls__HecEP carouselControls">
            <div v-if="!isMobile" class="Carousel_carouselArrowWrapper__7vECO" @click="carouseClick('prev')">
              <div class="Carousel_carouselArrow__YV3L6 carouselArrowPrev">
                <i></i>
                <i></i>
              </div>
            </div>
            <div class="Carousel_carouselPagination__dClSG carouselPagination">
                    <span v-for="(item,index) in cpList" :key="index"
                          class="Carousel_carouselPaginationItem__g0Rld carouselPaginationItem"
                          :class="{'Carousel_carouselPaginationActive__fh9Dk carouselPaginationActive':currentSlide1===index}">
                    </span>
            </div>
            <div v-if="!isMobile" class="Carousel_carouselArrowWrapper__7vECO" @click="carouseClick('next')">
              <div class="Carousel_carouselArrow__YV3L6 Carousel_carouselArrowNext__o36BS carouselArrowNext">
                <i></i>
                <i></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contact-content">
      <div class="contact-bg">
        <h3 class="mode-title">联系我们</h3>
        <div class="text-up contact-en">contact us</div>
        <div class="bottom-address">
          <div>
            <p>集团总部地址：江苏省常州市延陵西路19号嘉宏世纪大厦33楼</p>
            <p>邮编：213000</p>
            <p>联系电话：0519-88160137</p>
            <p>传真：0519-88160137</p>
            <p>400服务监督热线：4008289980（工作时间:周一至周五8:30-17:30）</p>
          </div>
          <div class="address-right">
            <p>E-mail：jiahongfangchan@163.com </p>
            <p>人事招聘邮箱：hr@jiahonggroup.com</p>
            <p>联系电话：0519-88160131</p>
            <p>招商电话：0519-86807766</p>
            <p>招投标电话：0519-88162912</p>
          </div>
        </div>
        <h3 class="mode-title" style="margin-top:20px;">联系地址</h3>
        <div class="text-up contact-en">contact address</div>
        <div class="bottom-address big-address col-000">
          江苏省常州市延陵西路19号嘉宏世纪大厦33楼
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import topNav from '@/components/base/top-nav'
  import 'slick-carousel/slick/slick.css';
  import 'slick-carousel/slick/slick-theme.css';
  import $ from 'jquery';
  import 'slick-carousel';
  var that = null
  export default {
    name: "service",
    components:{
      topNav
    },
    data() {
      return {
        isMobile:false,
        currentSlide1:0,
        sliderIndex: 0,
        zsList:[
          {
            image:'',
            name:'星光天地',
            address:'江苏省常州市钟楼区晋陵路与吊桥路交叉口西南侧',
            phone:'0519-89190020',
          },
          {
            image:'',
            name:'孟河星光城',
            address:'江苏省常州市新北区孟河镇孟河大道转盘中心西南侧',
            phone:'0519-88110090',
          },
          {
            image:'',
            name:'奔牛星光城',
            address:'江苏省常州市新北区奔牛镇南观路和兴奔路交叉口西北侧',
            phone:'0519-85800028',
          },
          {
            image:'',
            name:'蔚蓝星光城',
            address:'江苏省常州市武进经开区龙城大道与曙兴路交叉口东南侧',
            phone:'0519-85800028',
          },
          {
            image:'',
            name:'空港星光城',
            address:'江苏省常州市新北区黄河西路与通达路交汇处',
            phone:'0519-85800028',
          },
          {
            image:'',
            name:'嘉宏灯贸中心',
            address:'江苏省常州市钟楼区邹区镇东方大道与312国道交叉口西南侧',
            phone:'0519-83389888',
          },
          {
            image:'',
            name:'诺诚高第星光里',
            address:'江苏省常州市天宁区中吴大道与丽华北路交叉口西北侧',
            phone:'0519-85800028',
          },
          {
            image:'',
            name:'云顶星光里',
            address:'江苏省常州市钟楼区怀德路与德清路交叉口西南侧',
            phone:'0519-85800028',
          }
        ],
        vehicles: [
          {
            "image": {
              "desktop": "1.png",
              "mobile": "1.png"
            }
          },
          {
            "image": {
              "desktop": "2.png",
              "mobile": "2.png"
            }
          },
          {
            "image": {
              "desktop": "3.png",
              "mobile": "3.png"
            }
          },
          {
            "image": {
              "desktop": "4.png",
              "mobile": "4.png"
            }
          }
        ],
        serviceList:[
          {
            icon: 's1.png',
            p1: '在线缴纳物业费',
            p2: '明细账单超仔细',
            b1: '无地点限制，一目了然列明细',
            b2: '无现金支付，提高服务新速度',
          },
          {
            icon:'s2.png',
            p1: '线上报事好方便',
            p2: '投诉报修速反馈',
            b1: '15分钟及时响应，1小时投诉反馈',
            b2: '6小时急修到位，12小时贴心服务',
          },
          {
            icon:'s3.png',
            p1: '智慧通行享便',
            p2: '社区安全有保障',
            b1: '智能门禁，自动识别无阻挡',
            b2: '访客通行，掌上扫码方便行',
          },
          {
            icon:'s4.png',
            p1: '小区热事掌上看',
            p2: '社交互动好热闹',
            b1: '热点讨论，提示公告常更新',
            b2: '睦邻如友，和谐人际大家庭',
          }
        ],
        cpList:[
          {
            img:'1.png',
            name:'物业缴费'
          },
          {
            img:'2.png',
            name:'报事报修'
          },
          {
            img:'3.png',
            name:'访客通行'
          },
          {
            img:'4.png',
            name:'便民服务'
          },
          {
            img:'5.png',
            name:'客服管家'
          },
          {
            img:'6.png',
            name:'风华智控'
          }
        ]
      }
    },
    mounted() {
      that = this
      this.handleResize()
      this.initSlider();
    },
    methods: {
      servicehandle(){
        this.goAnchorParent('.kf')
      },
      lsHandle(){
        this.goAnchorParent('.ls')
      },
      goAnchorParent(selector){
        var element = document.querySelector(selector);
        var elementPosition = element.getBoundingClientRect().top;
        window.scrollBy({
          top: elementPosition - 44,
          behavior: 'smooth' // 平滑滚动
        });
      },
      handleResize(){
        this.isMobile = window.innerWidth <= 720
      },
      /**
       * 初始化轮播
       */
      initSlider() {
        this.$nextTick(() => {
          $('.slider-cp').slick({
            arrows: false,
            initialSlide: 0,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  arrows: false,
                  draggable:true,
                }
              },
              {
                breakpoint: 721,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: false,
                  draggable:true,
                }
              }
            ]
          });
          $('.slider-cp').on('afterChange', function pauseSlideShow(event, slick, currentSlide){
            that.currentSlide1 = currentSlide
          });
        });
      },
      carouseClick(type){
        if(type == 'prev'){
          $(".slider-cp").slick("slickPrev");
        }else{
          $(".slider-cp").slick("slickNext");
        }
      },
      /**
       * 轮播切换
       * @param index
       */
      pagination1Click(index){
        $('.slider-cp').slick('slickGoTo', index);
      }
    }
  }
</script>

<style>
  @import "../../styles/service.css";
</style>
